(function(){
  'use strict';

  /* ---- single source of truth for pricing ---- */
  var RRP = 54.95, DAYS_PER_TUB = 45;
  var PLANS = {
    '0': {tubs:1, unit:54.95, total: 54.95, label:'One-time',      save:'',         selling_plan: ''},
    '1': {tubs:1, unit:54.95, total: 54.95, label:'Monthly',       save:'',         selling_plan: '3657564212'},
    '3': {tubs:3, unit:49.98, total: 149.95, label:'3-month plan',  save:'Save 9%',  selling_plan: '3744006196'},
    '6': {tubs:6, unit:43.32, total: 259.95, label:'6-month plan',  save:'Save 21%', selling_plan: '3744038964'}
  };

  var state = {plan:'3', qty:0, selling_plan: PLANS['3'].selling_plan};

  var $  = function(id){return document.getElementById(id);};
  var $$ = function(sel){return Array.prototype.slice.call(document.querySelectorAll(sel));};
  var money  = function(n){return '$' + n.toFixed(2);};
  var perDay = function(n){return n < 1 ? Math.round(n*100) + 'c a day' : '$' + n.toFixed(2) + ' a day';};

  function render(){
    var p    = PLANS[state.plan];
    var sub  = p.total * state.qty;
    var save = (RRP * p.tubs * state.qty) - sub;
    var day  = p.unit / DAYS_PER_TUB;
    var tubs = p.tubs * state.qty;

    /* page: selected option + sticky bar */
    $$('.opt').forEach(function(o){ o.classList.toggle('sel', o.dataset.plan === state.plan); });
    if ($('stickyPrice')) $('stickyPrice').textContent = money(p.unit * p.tubs);
    if ($('stickyDay')) $('stickyDay').textContent   = perDay(day);

    /* drawer */
    $$('.plan').forEach(function(b){ b.classList.toggle('on', b.dataset.plan === state.plan); });
    
    if (state.qty === 0) {
      if ($('cartItems')) $('cartItems').style.display = 'none';
      if ($('cartFoot')) $('cartFoot').style.display = 'none';
      if ($('emptyCart')) $('emptyCart').style.display = 'block';
      if ($('cartDot')) $('cartDot').style.display = 'none';
      if ($('hCount')) $('hCount').textContent = '(0 items)';
    } else {
      if ($('cartItems')) $('cartItems').style.display = 'block';
      if ($('cartFoot')) $('cartFoot').style.display = 'block';
      if ($('emptyCart')) $('emptyCart').style.display = 'none';
      if ($('cartDot')) $('cartDot').style.display = 'flex';
      
      if ($('qtyVal')) $('qtyVal').textContent    = state.qty;
      if ($('cartDot')) $('cartDot').textContent   = state.qty;
      if ($('hCount')) $('hCount').textContent    = '(' + state.qty + (state.qty === 1 ? ' item)' : ' items)');
      if ($('lineVar')) $('lineVar').textContent   = tubs + (tubs === 1 ? ' tub  ' : ' tubs  ') + p.label;
      if ($('lineBadge')) $('lineBadge').textContent = p.save;
      if ($('lineBadge')) $('lineBadge').style.display = p.save ? 'inline-block' : 'none';
      if ($('linePrice')) $('linePrice').innerHTML = money(p.unit) + ' <span style="font-size:0.6em; font-weight:normal;">/ tub</span>';
      if ($('lineDay')) $('lineDay').textContent   = perDay(day) + (tubs > 1 ? ' · ' + money(sub) + ' total' : '');
      if ($('sub')) $('sub').textContent       = money(sub);
      if ($('savings')) $('savings').textContent   = save > 0 ? '−' + money(save) : '—';
      if ($('total')) $('total').textContent     = money(sub);
      if ($('totalDay')) $('totalDay').textContent  = 'Works out to ' + perDay(day);
      if ($('cartItemImage')) {
        var mainImg = document.querySelector('.gal-main img');
        if (mainImg) {
          $('cartItemImage').src = mainImg.src;
          $('cartItemImage').style.display = 'block';
          if ($('cartItemFallback')) $('cartItemFallback').style.display = 'none';
        }
      }
    }
  }

  /* ---- cart drawer open/close ---- */
  var drawer = $('drawer'), scrim = $('scrim'), lastFocus = null;

  function openCart(){
    lastFocus = document.activeElement;
    if (drawer) drawer.classList.add('open');
    if (scrim) scrim.classList.add('open');
    document.body.classList.add('locked');
    if ($('closeCart')) $('closeCart').focus();
  }
  function closeCart(){
    if (drawer) drawer.classList.remove('open');
    if (scrim) scrim.classList.remove('open');
    document.body.classList.remove('locked');
    if(lastFocus) lastFocus.focus();
  }

  $$('.js-atc').forEach(function(b){ 
    b.addEventListener('click', function(e) {
      if (state.qty === 0) state.qty = 1;
      
      var variantId = window.currentVariantId;
      if (!variantId) {
        render();
        openCart();
        return;
      }
      
      var bBtn = e.currentTarget;
      var originalText = bBtn.innerHTML;
      bBtn.innerHTML = 'Adding...';
      
      var formData = {
        'items': [{
          'id': variantId,
          'quantity': state.qty,
          'selling_plan': state.selling_plan
        }]
      };

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/clear.js', {
        method: 'POST'
      }).then(function() {
        return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
      })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        bBtn.innerHTML = originalText;
        render();
        openCart();
      })
      .catch(function(error) {
        console.error('Error:', error);
        bBtn.innerHTML = originalText;
      });
    }); 
  });
  
  if ($('openCart')) $('openCart').addEventListener('click', openCart);
  if ($('closeCart')) $('closeCart').addEventListener('click', closeCart);
  if ($('keepShopping')) $('keepShopping').addEventListener('click', closeCart);
  if ($('continueShoppingEmpty')) $('continueShoppingEmpty').addEventListener('click', closeCart);
  if (scrim) scrim.addEventListener('click', closeCart);
  $$('.checkout').forEach(function(b){
    b.addEventListener('click', function(){
      if (b.id !== 'continueShoppingEmpty') {
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
      }
    });
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && drawer && drawer.classList.contains('open')) closeCart();
  });

  /* ---- plan selection, both places ---- */
  $$('.opt, .plan').forEach(function(el){
    el.addEventListener('click', function(){
      state.plan = el.dataset.plan;
      if (el.dataset.sellingPlan !== undefined) {
        state.selling_plan = el.dataset.sellingPlan;
      } else {
        state.selling_plan = PLANS[state.plan].selling_plan;
      }
      render();
    });
  });

  /* ---- quantity ---- */
  $$('.qty button').forEach(function(b){
    b.addEventListener('click', function(){
      state.qty = Math.max(1, state.qty + parseInt(b.dataset.step, 10));
      render();
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({'line': 1, 'quantity': state.qty})
      });
    });
  });

  /* ---- remove item ---- */
  $$('.rm').forEach(function(b){
    b.addEventListener('click', function(){
      state.qty = 0;
      var originalText = b.innerHTML;
      b.innerHTML = '...';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/clear.js', {
        method: 'POST'
      }).then(function() {
        b.innerHTML = originalText;
        render();
      }).catch(function() {
        b.innerHTML = originalText;
        render();
      });
    });
  });

  /* ---- gallery thumbs ---- */
  $$('.thumb').forEach(function(t){
    t.addEventListener('click', function(){
      $$('.thumb').forEach(function(x){ x.classList.remove('on'); });
      t.classList.add('on');
    });
  });

  /* ---- scroll reveal ---- */
  var els = $$('.reveal');
  if(!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    els.forEach(function(e){ e.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, {threshold:.1});
    els.forEach(function(e){ io.observe(e); });
  }

  render();
})();

/* Force Sync */
